import IconGlowWrapper from '@/app/components/IconGlowWrapper'
import { useGame } from '@/app/providers/GameContextProvider'
import { useTranslation } from '@/hooks/useTranslation'
import React from 'react'
import { GameStep } from '@/lib/types/common/GameStep'
import { FaGamepad } from 'react-icons/fa'

const ServerInfoGameMode = () => {
    const { gameState } = useGame()
    const { t } = useTranslation()

    if (!gameState || (gameState?.gameStep !== GameStep.GUESSING && gameState?.gameStep !== GameStep.RESULT)) return null;

    return (
        <div className="flex gap-2 items-center">
            <IconGlowWrapper icon={<FaGamepad />} className="text-[18px] xl:text-[22px] translate-y-[-1px] pointer-events-none" color="yellow" />
            <span className="text-xs xl:text-base">{t(`game.modes.${gameState.gameMode}.nameMode`)}</span>
        </div>
    )
}

export default ServerInfoGameMode